import React, { Component } from 'react';
import { Box, Button, DataTable } from '../../../common/components';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { push } from 'react-router-redux';
import { Col, ControlLabel, FormControl, Row } from 'react-bootstrap';
import { InternalButtonBar } from '../../layout/components/InternalButtonBar/InternalButtonBar';
import selectTheme from '../../../helpers/selectTheme';
import { applyFilter } from '../../../common/components/DataTable/redux/dataTableActions';
import Select from 'react-select';
import { connect } from 'react-redux';

class ChannelsTable extends Component {
  constructor() {
    super();

    this.state = {
      values: {
        search: '',
        whitelabel: null,
        status: '',
      },
    };
  }

  handleRowClick = (row) => {
    const { dispatch } = this.props;
    dispatch(push('/admin/channels/' + row.id));
  };

  handleStatusUpdate(option) {
    this.props.dispatch(
      applyFilter('channels', 'filter[status]', option ? option.value : ''),
    );
  }

  handleWhiteLabelsFilterUpdate(option) {
    this.props.dispatch(
      applyFilter('channels', 'filter[whitelabel]', option ? option.value : ''),
    );
  }

  handleSearchUpdate(event) {
    this.setState({
      values: {
        ...this.state.values,
        search: event.target.value,
      },
    });
    this.props.dispatch(applyFilter('channels', 'filter[name]', event.target.value));
  }

  render() {
    return (
      <div>
        <Box>
          <Row>
            <Col sm={4}>
              <ControlLabel>Search</ControlLabel>
              <FormControl onChange={::this.handleSearchUpdate} />
            </Col>
            <Col sm={4}>
              <ControlLabel>White Labels</ControlLabel>
              <Select
                theme={(theme) => selectTheme(theme)}
                options={[
                  { label: 'White Labels', value: true },
                  { label: 'Non White Labels', value: false },
                ]}
                isClearable
                onChange={(option) => this.handleWhiteLabelsFilterUpdate(option)}
              />
            </Col>
            <Col sm={4}>
              <ControlLabel>Status</ControlLabel>
              <Select
                theme={(theme) => selectTheme(theme)}
                options={[
                  { label: 'Active', value: 'active' },
                  { label: 'Inactive', value: 'inactive' },
                  { label: 'Pending', value: 'pending' },
                ]}
                isClearable
                onChange={(option) => this.handleStatusUpdate(option)}
              />
            </Col>
          </Row>
        </Box>

        <Box>
          <DataTable
            source="/channels"
            name="channels"
            showTotal
            onRowSelect={this.handleRowClick.bind(this)}
          >
            <TableHeaderColumn dataField="id" isKey hidden />

            <TableHeaderColumn dataField="name" dataSort width={'20%'}>
              Name
            </TableHeaderColumn>

            <TableHeaderColumn dataField="channel_type" dataSort width={'10%'}>
              Channel Type
            </TableHeaderColumn>

            <TableHeaderColumn dataField="key" dataSort width={'10%'}>
              Key
            </TableHeaderColumn>

            <TableHeaderColumn dataField="url" dataSort={false} width={'15%'}>
              URL
            </TableHeaderColumn>

            <TableHeaderColumn dataField="whitelabel" dataSort={false} width={'10%'}>
              White Label
            </TableHeaderColumn>

            <TableHeaderColumn dataField="status" dataSort={false} width={'10%'}>
              Status
            </TableHeaderColumn>
          </DataTable>

          <Row>
            <Col sm={12}>
              <InternalButtonBar
                buttons={[
                  {
                    permissions: ['marketing.source_create'],
                    button: (
                      <Button
                        link
                        to="/admin/channels/new"
                        className="pull-right"
                        bsStyle="primary"
                        label="New Channel"
                      />
                    ),
                  },
                ]}
              />
            </Col>
          </Row>
        </Box>
      </div>
    );
  }
}

export default connect()(ChannelsTable);
